import { useState } from 'react';

const faqs = [
  {
    q: 'Tente sistemleri rüzgara dayanıklı mı?',
    a: 'Evet. Kullandığımız tente sistemleri Ege\'nin sert rüzgar koşullarına göre test edilmiştir. Kasetli ve mafsallı tentelerimiz belirli rüzgar hızlarına kadar güvenle kullanılabilir. Rüzgar sensörü opsiyonu ile otomatik kapanma özelliği de eklenebilir.',
  },
  {
    q: 'Pergola sistemleri dört mevsim kullanılır mı?',
    a: 'Bioklimatik ve otomatik pergola sistemlerimiz dört mevsim kullanıma uygundur. Ayarlanabilir alüminyum lamellerle yaz güneşini, kış yağmurunu ve rüzgarı kontrol altına alabilirsiniz. Alaçatı\'nın iklim koşullarına özel çözümler sunuyoruz.',
  },
  {
    q: 'Zip perde ne işe yarar?',
    a: 'Zip perde, terası veya balkonunuzu rüzgar, yağmur, böcek ve toz gibi dış etkenlere karşı korur. Şeffaf veya opak seçenekleriyle hem görsel mahremiyet hem de iklim kontrolü sağlar. Alaçatı\'nın meltem rüzgarına karşı özellikle tercih edilen bir sistemdir.',
  },
  {
    q: 'Şeffaf branda yağmur geçirir mi?',
    a: 'Hayır. Doğru montaj yapıldığında şeffaf PVC branda sistemlerimiz yağmur geçirmez. Yüksek kaliteli, UV dayanımlı PVC malzeme kullanıyoruz. Hem görüşü engellemeyen şeffaf yapısı hem de tam koruma özelliğiyle restoran ve kafe teraslarında yaygın olarak tercih edilmektedir.',
  },
  {
    q: 'Montaj ne kadar sürer?',
    a: 'Proje büyüklüğüne göre değişmekle birlikte, standart bir tente montajı genellikle 1 gün içinde tamamlanır. Pergola sistemleri 2-3 gün sürebilir. Keşif sonrası size net bir zaman çizelgesi sunuyoruz.',
  },
  {
    q: 'Alaçatı dışına da hizmet veriyor musunuz?',
    a: 'Evet. Çeşme, Ilıca, Ovacık, Dalyan ve Reisdere başta olmak üzere İzmir\'in Ege kıyı bölgelerine aktif olarak hizmet veriyoruz.',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-24 bg-[#111827]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12">
          {/* Left */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <span className="w-8 h-px bg-[#D4A853]"></span>
              <span className="text-[#D4A853] text-xs font-bold tracking-widest uppercase">Merak Edilenler</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-black text-white leading-tight mb-6">
              Sık Sorulan<br />Sorular
            </h2>
            <p className="text-white/40 text-sm leading-relaxed">
              Tente, pergola ve branda sistemleri hakkında en çok sorulan sorular. Aklınızdaki soruyu bulamadıysanız bizi arayın.
            </p>
          </div>

          {/* Right: FAQ */}
          <div className="lg:col-span-3 space-y-2">
            {faqs.map((faq, i) => (
              <div key={i} className={`border transition-colors ${openIndex === i ? 'border-[#D4A853]/40 bg-white/5' : 'border-white/10 bg-transparent'}`}>
                <button
                  className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer"
                  onClick={() => setOpenIndex(openIndex === i ? null : i)}
                >
                  <h3 className={`font-bold text-sm pr-4 transition-colors ${openIndex === i ? 'text-[#D4A853]' : 'text-white'}`}>
                    {faq.q}
                  </h3>
                  <div className={`w-7 h-7 flex items-center justify-center flex-shrink-0 border transition-colors ${openIndex === i ? 'border-[#D4A853] bg-[#D4A853]' : 'border-white/20'}`}>
                    <i className={`text-sm transition-transform duration-200 ${openIndex === i ? 'ri-subtract-line text-[#111827]' : 'ri-add-line text-white'}`}></i>
                  </div>
                </button>
                {openIndex === i && (
                  <div className="px-6 pb-5">
                    <p className="text-white/50 text-sm leading-relaxed">{faq.a}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
